import { getSdk } from "./sdkService";

/**
 * Get user's addons with payment info
 * @public
 */
export async function getUserSubscriptionsStatus() {
    try {
      const sdk = await getSdk();
      return await sdk.userManager.getSubscriptionsStatus();
    } catch (error) {
      throw error;
    }
}
  